/**
 * ScrollableList virtualization — 콘텐츠 항목 컬링 가시 판정 (Phaser 비의존 순수 함수).
 *
 * 항목이 viewport [0, viewportH](스크린 좌표) 안에 보이는지 판정해, 화면 밖 항목은 호출자가
 * `setVisible(false)`로 렌더/GeometryMask CPU 클립 비용을 제거하게 한다(off-screen 항목이 100+개일 때
 * 매 스크롤 프레임 비용이 보이는 ~6~10개로 줄어든다).
 *
 * - `ly` = 항목의 콘텐츠 좌표 y(center-origin). `ly - scrollY`가 스크린 y.
 * - `margin` = 항목 1개 높이만큼 위/아래 여유. 부분 가시 항목(center가 viewport 밖이지만 몸통 일부가 걸친
 *   항목)이 잘리는 깜빡임을 막고, 스크롤 시 팝인을 완충한다.
 * - 경계는 inclusive(`>=` / `<=`) — 정확히 경계에 걸친 항목을 보이게 해 클립 깜빡임을 막는다.
 */
export function isItemVisible(
  ly: number,
  scrollY: number,
  viewportH: number,
  margin: number,
): boolean {
  const screenY = ly - scrollY;
  return screenY >= -margin && screenY <= viewportH + margin;
}
